export default function getResource(label, vars = []) {
    const resources = {
        yearAtGlanceTitle: `${vars[0]} en un coup d’œil`,
        yearAtGlanceError: 'Nous n’arrivons pas à charger votre historique annuel pour le moment.',
        yearAtGlanceSignedOut: `Ouvrez une session pour accéder à votre ${vars[0]} en un coup d’œil.`,
        yearAtGlanceNonBi: `Adhérez pour accéder à votre ${vars[0]} en un coup d’œil.`,
        yearAtGlanceEmpty: `Vos gains de ${vars[0]} apparaîtront ici. Continuez à magasiner pour obtenir des récompenses, des privilèges et des réductions!`,
        rewardsRedeemedTitle: 'Récompenses réclamées',
        rewardsRedeemedError: 'Nous n’arrivons pas à charger vos récompenses utilisées pour le moment.',
        rewardsRedeemedSignedOut: 'Ouvrez une session pour accéder à vos récompenses utilisées.',
        rewardsRedeemedNonBi: 'Inscrivez-vous pour commencer à accumuler des points et à profiter des récompenses.',
        rewardsRedeemedEmpty: 'Vos récompenses réclamées s’afficheront ici.',
        pointsHistoryTitle: 'Points History',
        pointsHistoryInfoLabel: 'Points History information',
        pointsHistoryError: 'We couldn\'t load your points history right now.',
        pointsHistorySignedOut: 'Sign in to access your points history.',
        pointsHistoryNonBi: 'Join to start earning points and track your points history.',
        pointsHistoryEmpty: 'Your points history will appear here.',
        pointsDisclaimer: 'Don\'t see your points yet? Your activity will update within 24 hours.',
        pointsInfoModalMessage: 'Points from eligible purchases and activity may take up to 24 hours to appear in your account.',
        modalOk: 'OK',
        viewDetails: 'Voir les détails',
        viewAll: 'View all',
        shopNow: 'Magasiner',
        retry: 'Retry',
        loadingPointsHistory: 'Loading points history',
        faqs: 'FAQs',
        terms: 'Beauty Insider Terms & Conditions',
        employeeDiscountPurchase: 'Achat avec rabais de membre du personnel',
        promosAndDiscountApplied: 'Promotions et réductions appliquées',
        beautyInsiderCashApplied: 'Dollars Beauty Insider appliqués',
        creditCardRewardsEarned: 'Récompenses carte de crédit obtenues',
        rougeRewardsEarned: 'Récompenses Rouge obtenues'
    };

    return resources[label];
}
